// Data sevice
import axios from 'axios'
import authHeader from './auth-header'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const API_URL = process.env.VUE_APP_API_URL;

class ListingDisputesService {

    /**
     * Fetches disputes related to a specific listing.  
     * @param {number} id - The ID of the listing to fetch disputes for.
     * @returns {Promise} - A promise that resolves to the response of the API call
     * 
     * This method retrieves disputes associated with a specific listing by its ID.
     * It sends a GET request to the API endpoint 'listing-disputes/{id}'
     * where `{id}` is replaced with the actual listing ID.
     * The request includes authentication headers obtained from the `authHeader` function.
     * The response will contain the disputes related to the specified listing.
     */

    getAllListingDisputes() {
        return axios.get(API_URL + 'listing-disputes', { headers: authHeader() })
    }

    listingDisputes(id) {
        return axios.get(API_URL + 'listing-disputes/' + id, { headers: authHeader() })
    }

    store(resource) {
        return axios.post(API_URL + 'report-a-listing', resource, { headers: authHeader() })
    }

}

export default new ListingDisputesService()